import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ParksChart = ({ parks }) => {
  const parseNumber = (value) => {
    if (value == null) return 0;
    const cleaned = String(value).replace(/,/g, "");
    const n = Number(cleaned);
    return Number.isNaN(n) ? 0 : n;
  };

  const data = {
    labels: parks.map((p) => p.park),
    datasets: [
      {
        label: "Acres",
        data: parks.map((p) => parseNumber(p.acres)),
        backgroundColor: "#2A9D8F",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
      title: {
        display: true,
        text: "Utah National Parks Land Area",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y.toLocaleString()} acres`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "National Park",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Acres",
        },
      },
    },
  };

  return (
    <div className="bg-white p-8 shadow-xl rounded-xl">
      <div className="w-full h-[460px]">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ParksChart;